export default function (theme) {
    return {
        MuiButton: {
            styleOverrides: {
                root: {
                    padding: [[4, 16]]
                },
                text: {
                    fontWeight: 600
                },
                label: {
                    fontWeight: 600
                },
                outlinedPrimary: {
                    borderWidth: 2,
                    background: theme.palette.background.paper,
                    borderColor: theme.palette.primary.main,
                    '&:hover': {
                        borderWidth: 2,
                    }
                },
                outlinedSecondary: {
                    borderWidth: 2,
                    '&:hover': {
                        borderWidth: 2,
                    }
                },
                containedPrimary: {
                    borderWidth: 2,
                    borderStyle: 'solid',
                    borderColor: theme.palette.primary.main,
                    '&.Mui-disabled': {
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        opacity: 0.4,
                    },
                    '&:focus': {
                        borderWidth: 2,
                        borderStyle: 'solid',
                        borderColor: theme.palette.secondary.main
                    }
                },
                containedSecondary: {
                    borderWidth: 2,
                    borderStyle: 'solid',
                    borderColor: theme.palette.primary.main,
                    '&.Mui-disabled': {
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        opacity: 0.4,
                    },
                    '&:focus': {
                        borderWidth: 2,
                        borderStyle: 'solid',
                        borderColor: theme.palette.secondary.main
                    }
                }
            }
        }
    };
}